export const STATUS_MAP = {
  SCHEDULED: { color: "blue-grey", label: "Scheduled" },
  QUEUED: { color: "blue", label: "Queued" },
  RINGING: { color: "indigo", label: "Ringing" },
  IN_PROGRESS: { color: "purple", label: "In Progress" },
  COMPLETED: { color: "green", label: "Completed" },
  FAILED: { color: "red", label: "Failed" },
  CANCELLED: { color: "grey", label: "Cancelled" },
};

export const OUTCOME_MAP = {
  info_obtained: "Info Obtained",
  voicemail: "Voicemail",
  no_answer: "No Answer",
  nav_failed: "IVR Nav Failed",
  fax_requested: "Fax Requested",
  callback_scheduled: "Callback Scheduled",
  provider_left_practice: "Provider Left Practice",
  patient_left_practice: "Patient Left Practice",
  hung_up: "Hung Up",
  other: "Other",
};

export const TERMINAL_STATUSES = ["COMPLETED", "FAILED", "CANCELLED"];

export function statusColor(s) {
  return (STATUS_MAP[s] || {}).color || "grey";
}

export function statusLabel(s) {
  return (STATUS_MAP[s] || {}).label || s;
}

export function outcomeLabel(o) {
  return OUTCOME_MAP[o] || o;
}

// Live-poll gating: a call is "actively dialing" while it's worth fast-polling — pre-dial claim
// states and in-flight calls (age-bounded from the intended dial time so a stuck row can't poll
// forever), plus SCHEDULED rows whose send time is imminent/just-passed.
export const LIVE_POLL_MS = 4000;
const SCHEDULED_POLL_WINDOW_MS = 30 * 60 * 1000;
const LIVE_POLL_MAX_AGE_MS = 45 * 60 * 1000;

export function isActivelyDialing(call, now = Date.now()) {
  if (["QUEUED", "RINGING", "IN_PROGRESS"].includes(call.status)) {
    const origin = Math.max(
      call.createdOn ? new Date(call.createdOn).getTime() : 0,
      call.scheduledFor ? new Date(call.scheduledFor).getTime() : 0
    );
    return !origin || now - origin <= LIVE_POLL_MAX_AGE_MS;
  }
  if (call.status !== "SCHEDULED") return false;
  const at = call.scheduledFor ? new Date(call.scheduledFor).getTime() : NaN;
  if (isNaN(at)) return false;
  const sinceDue = now - at;
  return sinceDue >= -LIVE_POLL_MS && sinceDue <= SCHEDULED_POLL_WINDOW_MS;
}

// LAM-4824: a BV capture is suspect when the analysis graded the rep unreliable (long pauses,
// checked-with-others/holds, shaky answers) — flag it in the UI so staff retry the call.
export function isAccuracySuspect(call) {
  const details = call?.outcomeDetails;
  if (!details) return false;
  const raw = details.repReliabilityFlags;
  const flags = typeof raw === "string" && raw ? [raw] : raw;
  const confidence = String(details.captureConfidence || "")
    .trim()
    .toLowerCase();
  return ["low", "medium"].includes(confidence) || (Array.isArray(flags) && flags.length > 0);
}
